<template>
  <div class="form-section-header">
    <div class="info">
      <div class="title">
        {{ title }}
        <span class="changed-dot" v-if="isChanged"></span>
      </div>
      <div class="description" v-if="description" v-html="description"></div>
    </div>

    <div class="controls">
      <slot name="controls" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSectionHeader',

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    isChanged: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>

<style scoped>
.form-section-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 20px;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #4b515f;
}

.description {
  color: #7e8596;
  margin-top: 4px;
  font-size: 12px;
}

.controls {
  text-align: right;
  white-space: nowrap;
  padding-left: 20px;
}

.controls > *:last-child {
  margin-right: 0;
}
.changed-dot {
  height: 5px;
  width: 5px;
  background-color: #c81d87;
  border-radius: 50%;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/FormSectionHeader.vue